import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { SpacesList } from '@components/templates/spaces';

export function SpacesListPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('spaces-page.metatags.title'),
        description: t('spaces-page.metatags.description'),
    };

    useSEOMetatags({
        ...translations,
        url: SITE_URLS.recoverPassword,
        index: false,
    });

    return <SpacesList />;
}
